import { Button } from 'components/ui/button';
import { Typography } from 'components/ui/typography';

interface UserLoadErrorProps {
  retrying: boolean;
  onRetry: () => void;
  onSignOut: () => void;
}

export function UserLoadError({ retrying, onRetry, onSignOut }: UserLoadErrorProps) {
  return (
    <div className="flex max-w-md flex-col items-start gap-4">
      <div role="alert" className="flex flex-col items-start gap-4">
        <Typography variant="h3">Couldn't load your account</Typography>
        <Typography variant="body" className="text-[var(--text-muted)]">
          Something went wrong while loading your account. You can try again or sign out.
        </Typography>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <Button type="button" onClick={onRetry} disabled={retrying}>
          {retrying ? 'Trying again...' : 'Try again'}
        </Button>
        <Button type="button" variant="outline" onClick={onSignOut}>
          Sign out
        </Button>
      </div>
    </div>
  );
}
